import React, { useState, useEffect } from "react";
import { Table, message, Card, Avatar, Typography } from "antd";
import { baseImageUrl } from "Common/Components/baseImageUrl";
import { UserOutlined } from "@ant-design/icons";

const { Text } = Typography;

const MentorsList = () => {
  const [mentors, setMentors] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");

  const fetchMentors = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/Mentor/GetListAll`, {
        method: "GET",
        headers: {
          accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch mentors");
      }

      const data = await response.json();
      setMentors(data);
    } catch (error) {
      console.error("Error fetching mentors:", error);
      message.error("Failed to load mentors data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMentors();
  }, []);

  const columns = [
    {
      title: "Mentor",
      dataIndex: "profileImage",
      key: "profileImage",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Avatar
            src={record.profileImage ? `${baseImageUrl}${record.profileImage}` : null}
            icon={!record.profileImage && <UserOutlined />}
            size="large"
            style={{
              backgroundColor: record.profileImage ? "transparent" : "#f56a00",
            }}
          />
          <Text strong>
            {record.firstName} {record.lastName}
          </Text>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "phoneNo",
      key: "phoneNo",
      render: (text) => (text ? text : "N/A"),
    },
    {
      title: "Date Joined",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (date) => new Date(date).toLocaleDateString(),
    },
  ];

  return (
    <Card className="card-professional" title="Mentors List" bordered={false}>
      <Table
        columns={columns}
        dataSource={mentors}
        rowKey="mentorId"
        loading={loading}
        pagination={true}
        scroll={{ x: true }}
      />
    </Card>
  );
};

export default MentorsList;
